// Client-side AI helpers that mirror the mobile app's admin tools.
// The only real LLM endpoint is /admin/ai/describe; the pricing/divide/fairness/skill
// helpers below are deterministic heuristics (same as the app).

export const SKILL_BANK = [
  { question: "What is 2 + 3?", options: ["4", "5", "6", "7"], answer_index: 1 },
  { question: "How many wheels does a standard car have?", options: ["2", "3", "4", "5"], answer_index: 2 },
  { question: "What colour is the sky on a clear day?", options: ["Green", "Blue", "Red", "Pink"], answer_index: 1 },
  { question: "What does a watch measure?", options: ["Distance", "Time", "Weight", "Heat"], answer_index: 1 },
  { question: "What is 10 divided by 2?", options: ["2", "3", "5", "8"], answer_index: 2 },
  { question: "How many days are in a week?", options: ["5", "6", "7", "8"], answer_index: 2 },
  { question: "What is the first letter of the alphabet?", options: ["A", "B", "C", "D"], answer_index: 0 },
];

export const randomSkill = () => SKILL_BANK[Math.floor(Math.random() * SKILL_BANK.length)];

// Suggest ticket price + quantity + break-even, keeping ~30% profit.
export const recommendPricing = (prizeValue, instantValue, mode) => {
  const cost = Number(prizeValue || 0) + Number(instantValue || 0);
  const targetRevenue = cost > 0 ? cost / 0.7 : 0;
  const price = mode === "cheap" ? 0.99 : 4.99;
  const total = Math.max(50, Math.ceil((targetRevenue || price * 500) / price));
  const breakEven = price > 0 && cost > 0 ? Math.ceil(cost / price) : 0;
  return { ticket_price: price, total_tickets: total, min_threshold: breakEven };
};

// Fairness cap: ~5% of total tickets per person.
export const recommendFairnessCap = (totalTickets) => Math.max(1, Math.round(Number(totalTickets || 0) * 0.05));

// Divide a total instant-win pot into a ladder of prizes on random ticket numbers.
export const divideInstantWins = (totalValue, totalTickets) => {
  const V = Number(totalValue || 0);
  if (V <= 0) return [];
  const tickets = Math.max(10, Number(totalTickets || 1000));
  const used = new Set();
  const rnd = () => {
    let n;
    let guard = 0;
    do { n = Math.floor(Math.random() * tickets) + 1; guard++; } while (used.has(n) && guard < 9999);
    used.add(n);
    return n;
  };
  const ladder = [
    { count: 1, frac: 0.4, type: "cash", label: "Big Cash Instant Win" },
    { count: 3, frac: 0.1, type: "cash", label: "Cash Instant Win" },
    { count: 10, frac: 0.03, type: "credit", label: "Site Credit Instant Win" },
  ];
  const out = [];
  ladder.forEach((t) => {
    for (let i = 0; i < t.count; i++) {
      const value = Math.round(V * t.frac);
      if (value <= 0) continue;
      out.push({ ticket_number: rnd(), prize_type: t.type, label: t.label, value });
    }
  });
  return out;
};

export const daysFromNowISO = (days) => new Date(Date.now() + Number(days || 7) * 86400000).toISOString();
